import { render, staticRenderFns } from "./SelectPerformance.vue?vue&type=template&id=1c1cdb25&scoped=true"
import script from "./SelectPerformance.vue?vue&type=script&lang=js"
export * from "./SelectPerformance.vue?vue&type=script&lang=js"
import style0 from "./SelectPerformance.vue?vue&type=style&index=0&id=1c1cdb25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1cdb25",
  null
  
)

export default component.exports